export const CREATE_ADMIN_CUSTOM_FORMS = "CREATE_ADMIN_CUSTOM_FORMS";   
export const RETRIEVE_ADMIN_CUSTOM_FORMS = "RETRIEVE_ADMIN_CUSTOM_FORMS";
export const RETRIEVESINGLE_ADMIN_CUSTOM_FORMS = "RETRIEVESINGLE_ADMIN_CUSTOM_FORMS";
export const UPDATE_ADMIN_CUSTOM_FORMS = "UPDATE_ADMIN_CUSTOM_FORMS";   
export const DELETE_ADMIN_CUSTOM_FORMS = "DELETE_ADMIN_CUSTOM_FORMS";   
